const SHEET_ID = "1BaXp1QBRfQWS0aqxy9699W1YT6hZkukk5bKINEXvI_A";
const SHEET_NAME = "Sheet1";
const API_KEY = "AIzaSyArPqZaRjxKYuY8CSZifVIyscbikI_-MVU";
const API_URL = `https://sheets.googleapis.com/v4/spreadsheets/${SHEET_ID}/values/${encodeURIComponent(SHEET_NAME)}?key=${API_KEY}`;

document.addEventListener("DOMContentLoaded", function () {
  initStoreLocator();
});

async function initStoreLocator() {
  const input = document.getElementById("storeSearch");
  const countLabel = document.getElementById("storeCount");
  const storeContainer = document.getElementById("storeCards");
  const template = document.getElementById("storeCardTemplate");
  const suggestionBox = document.getElementById("suggestionBox");

  const noResultsMessage = document.createElement("div");
  noResultsMessage.textContent = "No stores are available in this location.";
  noResultsMessage.classList.add("no-results-message");
  noResultsMessage.style.display = "none";
  storeContainer.appendChild(noResultsMessage);

  if (countLabel) countLabel.style.display = "none";

  const storeSuggestions = new Map();
  const cards = [];

  function normalize(str) {
    return str.toLowerCase().replace(/\s+/g, "");
  }

  try {
    const res = await fetch(API_URL);
    const data = await res.json();
    const rows = data.values;
    const headers = rows[0];
    const records = rows.slice(1);

    records.forEach((row, index) => {
      const rowData = headers.reduce((obj, key, i) => {
        obj[key.trim()] = row[i] ? row[i].trim() : "";
        return obj;
      }, {});

      const locationName = rowData["Name for store locator"] || rowData["Name"] || "";
      const storeName = rowData["Store Name"] || "";
      const address = rowData["Address"] || "";
      const mapLink = rowData["Map Link"] || rowData["Link"] || "";

      if (!locationName && !address) return;

      const clone = template.content.cloneNode(true);
      clone.querySelector(".store-location-name").textContent = locationName || "Location Name";
      clone.querySelector(".store-name").textContent = storeName || "";
      clone.querySelector(".store-address").textContent = address || "Address not available";
      
      // Show/hide store name element based on whether we have data
      const storeNameEl = clone.querySelector(".store-name");
      if (!storeName) {
        storeNameEl.style.display = "none";
      }
      
      const directionsAnchor = clone.querySelector(".store-directions a");
      if (mapLink) {
        directionsAnchor.href = mapLink.trim();
        directionsAnchor.target = "_blank";
      } else {
        directionsAnchor.href = "#";
      }

      const cardEl = clone.querySelector(".store-card");
      cardEl.setAttribute("data-location", locationName);
      cardEl.setAttribute("data-storename", storeName);
      cardEl.setAttribute("data-address", address);

      setTimeout(() => cardEl.classList.add("loaded"), 50 + (index * 50));
      storeContainer.appendChild(clone);
      cards.push(cardEl);

      if (locationName) {
        const nameKey = normalize(locationName);
        if (!storeSuggestions.has(nameKey)) {
          storeSuggestions.set(nameKey, { suggestion: locationName });
        }
      }

      if (storeName) {
        const storeKey = normalize(storeName);
        if (!storeSuggestions.has(storeKey)) {
          storeSuggestions.set(storeKey, { suggestion: storeName });
        }
      }

      if (address) {
        const addressParts = address.split(',').map(part => part.trim());
        addressParts.forEach(part => {
          const partKey = normalize(part);
          if (partKey && !storeSuggestions.has(partKey)) {
            storeSuggestions.set(partKey, { suggestion: part });
          }
        });
      }
    });

    const totalStoresEl = document.getElementById("totalStoresCount");
    if (totalStoresEl) totalStoresEl.textContent = records.length;

    function filterCards(term) {
      const normalizedTerm = normalize(term);
      let found = 0;

      cards.forEach(card => {
        const location = normalize(card.getAttribute("data-location") || "");
        const storename = normalize(card.getAttribute("data-storename") || "");
        const address = normalize(card.getAttribute("data-address") || "");
        const combined = `${location}${storename}${address}`;

        const isMatch = combined.includes(normalizedTerm);
        card.style.display = isMatch ? "flex" : "none";
        if (isMatch) found++;
      });

      noResultsMessage.style.display = found ? "none" : "block";
      if (countLabel) countLabel.textContent = `${found} Store${found !== 1 ? "s" : ""} found`;
    }

    function showAllCards() {
      cards.forEach(card => (card.style.display = "flex"));
      noResultsMessage.style.display = "none";
      if (countLabel) countLabel.style.display = "none";
    }

    function showSuggestions(searchTerm) {
      suggestionBox.innerHTML = "";
      if (!searchTerm) return;

      const normalizedSearch = normalize(searchTerm);
      const matches = Array.from(storeSuggestions.values()).filter(item =>
        normalize(item.suggestion).includes(normalizedSearch)
      );

      matches.slice(0, 10).forEach(item => {
        const div = document.createElement("div");
        div.classList.add("suggestion-place");
        div.textContent = item.suggestion;
        div.addEventListener("click", () => {
          input.value = item.suggestion;
          suggestionBox.innerHTML = "";
          filterCards(item.suggestion);
        });
        suggestionBox.appendChild(div);
      });
    }

    let debounce;
    input.addEventListener("input", () => {
      clearTimeout(debounce);
      debounce = setTimeout(() => {
        const term = input.value.trim();
        if (!term) {
          showAllCards();
          suggestionBox.innerHTML = "";
          return;
        }
        showSuggestions(term);
        filterCards(term);
      }, 150);
    });

    let selectedIndex = -1;
    let suggestionItems = [];

    input.addEventListener("keydown", e => {
      suggestionItems = Array.from(suggestionBox.querySelectorAll(".suggestion-place"));
      
      if (e.key === "ArrowDown") {
        e.preventDefault();
        if (selectedIndex < suggestionItems.length - 1) selectedIndex++;
        updateHighlight();
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        if (selectedIndex > 0) selectedIndex--;
        updateHighlight();
      } else if (e.key === "Enter") {
        e.preventDefault();
        
        // If a suggestion is selected, click it
        if (selectedIndex >= 0 && suggestionItems[selectedIndex]) {
          suggestionItems[selectedIndex].click();
        } else {
          // If no suggestion selected, filter with current input value
          const term = input.value.trim();
          if (term) {
            suggestionBox.innerHTML = "";
            filterCards(term);
          }
        }
      }
    });

    function updateHighlight() {
      suggestionItems.forEach((item, index) => {
        item.classList.toggle("highlighted", index === selectedIndex);
      });
    }

    document.addEventListener("click", e => {
      if (!input.contains(e.target) && !suggestionBox.contains(e.target)) {
        suggestionBox.innerHTML = "";
      }
    });

  } catch (err) {
    const totalStoresEl = document.getElementById("totalStoresCount");
    if (totalStoresEl) totalStoresEl.textContent = "0";
  }
}